import { useForm } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import { useFetcher } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'
import {
	SET_DEFAULT_ADDRESS_FORM,
	SET_DEFAULT_ADDRESS_INPUTS,
	setDefaultAddressSchema,
} from '#app/components/forms/set-default-address-form/set-default-address-form.tsx'
import { PROFILE_ADDRESSES_INDEX_I18NEXT } from '#app/routes/($lang).profile.addresses._index/route-config'
import { ROOT_INPUTS } from '#app/routes/_layout/route-config.ts'

type UseSetDefaultAddressProps = {
	id: number
	iri: string
}

function useSetDefaultAddressForm({ id, iri }: UseSetDefaultAddressProps) {
	const { t } = useTranslation(
		PROFILE_ADDRESSES_INDEX_I18NEXT.routeProfileAddressesIndex,
	)
	const isHydrated = useHydrated()

	const defaultAddressFetcherKey = SET_DEFAULT_ADDRESS_FORM.generateFetcherKey!(
		{
			id: String(id),
		},
	)
	const defaultAddressFetcher = useFetcher({
		key: defaultAddressFetcherKey,
	})
	const defaultAddressFormValues = {
		[ROOT_INPUTS.subaction]: SET_DEFAULT_ADDRESS_FORM.subaction,
		[ROOT_INPUTS.noJs]: String(!isHydrated),
		[SET_DEFAULT_ADDRESS_INPUTS.defaultAddress]: iri,
	}
	const [defaultAddressForm, defaultAddressFields] = useForm({
		lastResult: defaultAddressFetcher.data || undefined,
		onValidate({ formData }) {
			return parseWithZod(formData, {
				schema: setDefaultAddressSchema,
			})
		},
		shouldValidate: 'onSubmit',
	})

	return {
		defaultAddressFetcherKey,
		defaultAddressFetcher,
		defaultAddressFormValues,
		defaultAddressForm,
		defaultAddressFields,
		t,
	}
}

export { type UseSetDefaultAddressProps, useSetDefaultAddressForm }
